import {ValueObject} from '@s-ui/domain'

import {NumberSharedValueObject} from '../../shared/ValueObjects/NumberSharedValueObject.js'
import {StringSharedValueObject} from '../../shared/ValueObjects/StringSharedValueObject.js'

export class ReservationTransactionsValueObject extends ValueObject {
  #amount
  #createdAt
  #expirationDate

  constructor({amount, createdAt, expirationDate}) {
    super()

    this.#amount = amount
    this.#createdAt = createdAt
    this.#expirationDate = expirationDate
  }

  static create = ({amount, createdAt, expirationDate}) => {
    return new ReservationTransactionsValueObject({
      amount: NumberSharedValueObject.create({value: amount}),
      createdAt: StringSharedValueObject.create({value: createdAt}),
      expirationDate: StringSharedValueObject.create({value: expirationDate})
    })
  }

  get amount() {
    return this.#amount.value
  }

  get createdAt() {
    return this.#createdAt.value
  }

  get expirationDate() {
    return this.#expirationDate.value
  }

  get value() {
    return {
      amount: this.amount,
      createdAt: this.createdAt,
      expirationDate: this.expirationDate
    }
  }
}
